<template>
  <div
    class="under-production common-flex common-justify-between"
    :style="{ minHeight: 'calc(100vh - 120px)' }"
  >
    <div class="list">
      <rCenterHeader :width="1150" :list="headerMenu">
        <div slot="search" class="search">
          <form>
            <Select
              v-model="orderNums"
              ref="orderNumSelect"
              filterable
              :remote-method="remoteMethod"
              @on-change="changeMethod"
              :loading="loading"
              :label-in-value="true"
              style="width: 380px; color: #081938; height: 40px"
              :placeholder="$t('fabricLibrary.search')"
              @keydown.enter.native.prevent="searchs('')"
              suffix="ios-search"
              clearable
              @on-clear="clear"
            >
              <Option
                v-for="(option, index) in orderNumList"
                :value="option.orderCode + option.customOrderNo"
                :key="index"
                :label="option.orderCode"
              >
                <!-- {{ option.orderCode }}({{ option.source}}) -->
                <div class="common-flex common-justify-between">
                  <span>{{ option.customOrderNo ? option.orderCode + ' | ' + option.customOrderNo : option.orderCode}}</span>
                  <span style="float: right; color: #ccc">{{
                    option.source
                  }}</span>
                </div>
              </Option>
            </Select>
            <!-- <Input
              size="large"
              @keydown.enter.native.prevent="search('')"
              @on-click="search('')"
              v-model="params.keywords"
              icon="ios-search"
              :placeholder="$t('fabricLibrary.search')"
              style="width: 380px; color: #081938"
            /> -->
            <Button
              @click="filterClick"
              class="filter"
              size="large"
              type="primary"
            >
              <span class="iconfont iconshaixuan"></span>
              {{ $t("fabricLibrary.filter") }}
            </Button>

            <Button
              class="filter"
              size="large"
              type="primary"
              @click="handleExport"
            >
              <span>Export</span>
            </Button>
          </form>
        </div>
        <!-- <div slot="bottom">
          <div class="common-flex status-box common-rowUnder">
            <div
              class="status-item"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div> -->
      </rCenterHeader>
      <div class="product-list" style="padding-bottom: 80px">
        <rUnderOrder
          @changeCheck="changeCheck"
          @checkOptions="checkOptions"
          @details="details"
          @buyagain="handleBuyAgain"
          @cancel="cancel"
          v-for="(item, index) in list"
          :key="index"
          :index="index"
          :config="item"
        ></rUnderOrder>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <rNull
          v-if="list.length == 0 && spinShow == false"
          imgStyle="width:300px;margin:0 auto"
          titleStyle="font-size:16px;color:#999"
          :title="$t('noResult')"
        ></rNull>
        <div
          v-if="list.length > 0"
          class="select-all common-flex common-align-center common-justify-between"
        >
          <Checkbox @on-change="changeAll" v-model="allCheck">
            {{ $t("user.selectAll") }}
          </Checkbox>
          <Page
            v-if="list.length > 0"
            show-sizer
            :total="total"
            @on-change="changePage"
            @on-page-size-change="changeSize"
            :page-size="params.pageSize"
            :page-size-opts="[20, 40, 60, 80]"
            show-total
          >
            <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
          </Page>
          <div>
            {{ $t("user.check") }}: {{ ids.length }} {{ $t("user.items") }}
          </div>
        </div>
      </div>
    </div>
    <div class="total-price-box">
      <div
        class="address total-price common-rowUnder"
        :style="
          isFixed
            ? {
                position: 'fixed',
                top: 0,
                height: '100vh',
                overflowY: 'auto'
              }
            : {}
        "
      >
        <div class="title-box common-flex common-justify-between">
          <div class="delivery-address">
            {{ $t("underProduction.deliveryAddress") }}
          </div>
          <div class="create-new common-hover" @click="addAddress">
            {{ $t("underProduction.createNew") }}
          </div>
        </div>
        <div class="address-details" v-if="submitAddress">
          <div class="common-flex common-justify-between common-align-center">
            <div class="name">{{ submitAddress.contact }}</div>
            <div class="logo">
              <img :src="submitAddress.expressUrl" alt="" />
            </div>
          </div>
          <div class="details">
            {{ submitAddress.address }}
          </div>
          <div class="details" style="margin-bottom: 20px">
            {{ submitAddress.expressName }} |
            {{ submitAddress.expressTypeName }} |
            {{ submitAddress.payTypeName }}
          </div>
          <div class="options common-flex common-justify-between">
            <div class="edit common-hover" @click="edit">
              {{ $t("underProduction.edit") }}
            </div>
            <div
              class="add common-hover"
              @click="setDefault"
              v-if="submitAddress.isDefault != 1"
            >
              {{ $t("address.setDefault") }}
            </div>

            <div
              class="add"
              style="color: #0a4dcc; opacity: 1"
              v-if="submitAddress.isDefault == 1"
            >
              {{ $t("underProduction.defaultAdd") }}
            </div>
          </div>
        </div>
        <div class="choose-another common-hover" @click="chooseAddress">
          {{ $t("underProduction.another") }}
        </div>
        <div
          class="
            delivery-date-box
            common-align-center common-flex common-justify-between
          "
        >
          <div class="titles">{{ $t("underProduction.deliveryDate") }}</div>
          <div>
            <form>
              <DatePicker
                type="date"
                v-model="shipDate"
                @on-change="changeDate"
                :placeholder="$t('order.selectDate')"
                placement="bottom-end"
                style="width: 100px"
              ></DatePicker>
            </form>
          </div>
        </div>
        <div class="orders-selected">
          <form>
          <Input v-model="paramsLogistics.remark" placeholder="Add shipping notes" type="textarea" show-word-limit maxlength="200" :rows="4"></Input>
        </form>

        </div>
        <div class="orders-selected" style="margin-top: 0;">
          <span style="color: #0a4dcc"></span> {{ ids.length }}
          {{ $t("underProduction.ordersSelected") }}
        </div>
        <Button class="options-btn" :loading="loading" @click="submitLogistics">{{
          $t("underProduction.options")
        }}</Button>
      </div>
    </div>
    <rChooseAddress
      :submitAddress="submitAddress"
      @submit="submit"
      @back="back"
      :addressShow="addressShow"
      @handlerAddressShow="handlerAddressShow"
    ></rChooseAddress>
    <!-- <rUnderFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="orderfilteShow"
    ></rUnderFilter> -->
    <rOrderFilter
      filterType="order-ship"
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="orderfilteShow"
    ></rOrderFilter>
    <!-- <rOrderDetails
      :config="orderMsg"
      :hideStep="true"
      detailsType="picture"
    ></rOrderDetails> -->
    <Modal
      v-model="orderDetails"
      style="height: 90%"
      footer-hide
      fullscreen
      title=""
    >
      <div class="title-boxs">
        <div class="title">{{ $t("saveItems.CheckOptions") }}</div>
        <div
          @click="closeDetails"
          class="common-hover iconfont iconguanbi"
        ></div>
      </div>
      <rOrderDetails
        :config="orderMsg"
        :hideStep="true"
        detailsType="picture"
      ></rOrderDetails>
    </Modal>
    <rAddNewAddress
      :type="type"
      @saveConfirm="saveConfirm"
      :addressId="addressId"
      :addNew="addNew"
      @handlerAdd="handlerAdd"
    ></rAddNewAddress>
    <!-- 取消订单弹框 -->
    <rConfirmModal
      @confrim="confrim"
      :config="rConfirmModalConfig"
      :cancelShow="cancelShow"
      :spinShow="spinShow"
      @handlerCancelShow="handlerCancelShow"
    ></rConfirmModal>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions } from "vuex";
import rCenterHeader from "../../components/r-center-header";
import rAddNewAddress from "../../components/r-add-new-address";
import rUnderOrder from "../../components/r-under-order";
import rChooseAddress from "../../components/r-choose-address-modal";
import rUnderFilter from "../../components/r-under-filter";
import rOrderDetails from "../../components/r-order-details";
import rNull from "../../components/r-null";
import rOrderFilter from "../../components/r-order-filter";
import rConfirmModal from "../../components/r-confirm-modal";
import moment from "moment"

import { exportOrderList } from "../../api/logistics";
export default {
  name: "under-production",
  data() {
    return {
      isFixed: false,
      orderNumList: [],
      loading: false,
      orderNums: "",
      statusList: [], //状态列表

      rConfirmModalConfig: {
        content: this.$t("order.cancelTip"),
        cancel: this.$t("order.cancel"),
        confirm: this.$t("order.confirm")
      },
      total: 0,
      spinShow: false,
      orderDetails: false,
      // 提交数据
      paramsLogistics: {
        shipdate: "", //计划发货时间
        orderIds: "", //订单id
        remark: "", //备注
        address: "" //地址信息
      },
      allCheck: false,
      // 类型 0普通新增  1查看  2编辑
      type: 0,
      addNew: false,
      addressId: "",

      ids: [],
      // 订单详情
      orderMsg: "",
      // 订单列表
      list: [],
      // 搜索弹框
      orderfilteShow: false,
      value: "",
      // 是否显示地址列表
      addressShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("order.orderList")
        }
      ],
      params: {
        pageSize: 20,
        pageNum: 1,
        type: 2,
        userId: "", //账号
        status: "", //状态
        start: "", //开始时间
        end: "", //结束时间
        sizeCategoryId: "", //订单尺寸
        clothId: "", //当前选中产品id
        orderType: "", //订单类型
        keyWord: "",
        isShip: "0" //是否发货
      },
      // params: {
      //   pageNum: 1,
      //   pageSize: 20,
      //   keywords: "",
      //   startDeliveryDate: "",
      //   endDeliveryDate: "",
      // },
      submitAddress: "",
      cancelShow: false,
      cancelId: "",
      shipDate:""
    };
  },
  components: {
    rCenterHeader,
    rUnderOrder,
    rChooseAddress,
    rUnderFilter,
    rOrderDetails,
    rAddNewAddress,
    rNull,
    rOrderFilter,
    rConfirmModal
  },
  mounted() {
    this.params.keyWord = this.$route.query.orderNum;
    this.orderNums = this.$route.query.orderNum;
    if (this.$route.query.status) {
      this.params.status = this.$route.query.status;
    }
    // if(this.orderNums){
    //   this.remoteMethod(this.orderNums)
    // }
    this.addOrder();
    this.defaultAddress();
    this.getStatus();
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理

    // this.getOrderCartList()
  },
  watch: {
    addNew: {
      handler(newval, oldval) {
        if (!newval && this.submitAddress) {
          this.selectOneAddressAction({
            id: this.submitAddress.id
          }).then(res => {
            for (let key in this.submitAddress) {
              this.submitAddress[key] = res.data[key];
            }
          });
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler() {
        this.params.status = this.$route.query.status;
        this.addOrder();
        //深度监听，同时也可监听到param参数变化
      },
      deep: true
    },
    list: {
      handler(newval, oldval) {
        let pass = true;
        newval.map(item => {
          if (item.check == 0) {
            pass = false;
          }
        });
        this.allCheck = pass;
        this.calculationNum();
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions([
      "addOrderAction", //待发货列表
      "getCartOrderDetailAction", //详情
      "addressListAction", //默认地址
      "selectOneAddressAction", //查询地址
      "setDefaultAction", //设为默认
      "putShippingAction", //提交发货
      "getOrderCartListAction", //订单列表
      "canceMtmOrderAction", //取消订单
      "getOrderSearchAction", //订单状态
      "getOrderCodeListAction" //订单号列表
    ]),
    // 滚动到底部
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      //变量windowHeight是可视区的高度
      let offsetTop = document.querySelector(".address").offsetTop + 70; // 要滚动到顶部吸附的元素的偏移量
      this.isFixed = scrollTop > offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
      // let windowHeight =
      //   document.documentElement.clientHeight || document.body.clientHeight;
      // //变量scrollHeight是滚动条的总高度
      // let scrollHeight =
      //   document.documentElement.scrollHeight || document.body.scrollHeight;
      // //滚动条到底部的条件
      // // console.log("gundong", scrollTop + windowHeight, scrollHeight - 10);
      // if (scrollTop + windowHeight >= scrollHeight - 10) {
      //   //到了这个就可以进行业务逻辑加载后台数据了
      //   if (this.pages > this.params.pageNum) {
      //     this.params.pageNum++;
      //     // this.customer();
      //     this.getOrderCartList();
      //   }
      // }
    },
    // optionsa(e){
    //   console.log('e',e)
    // },
    clear() {
      this.params.pageNum = 1;
      this.params.keyWord = "";
      this.addOrder();
    },
    changeMethod(e) {
      let type = "";
      this.orderNumList.map(item => {
        if (e.label == item.orderCode) {
          type = item.source;
        }
      });
      if (type == "购物车") {
        this.$router.push("./saveItems?orderNum=" + e.label);
      } else if (type == "审核中订单") {
        this.$router.push("./myOrder?orderNum=" + e.label);
      } else {
        this.params.keyWord = e.label;
        this.addOrder();
      }
    },
    remoteMethod(e) {
      // let that = this;
      this.loading = true;
      this.getOrderCodeListAction({
        keyWord: e
      })
        .then(res => {
          this.loading = false;
          this.$set(this, "orderNumList", res.data);
          // console.log("this.orderNumList", this.orderNumList);
        })
        .finally(res => {
          this.loading = false;
        });
    },
    // 获得状态
    getStatus() {
      this.getOrderSearchAction({ category: 9, type: 21 }).then(res => {
        res.data.unshift({
          name: this.$t("all"),
          id: ""
        });
        this.statusList = res.data;
      });
    },
    confrim(e) {
      this.spinShow = true;
      this.canceMtmOrderAction({
        orderId: this.cancelId
      })
        .then(res => {
          if (res.code == 0) {
            // this.params.pageNum = 1;
            this.list = [];
            this.addOrder();
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally(res => {
          this.spinShow = false;
          this.cancelShow = false;
        });
    },
    cancel(e) {
      this.cancelShow = true;
      this.cancelId = e.orderId;
    },
    //   隐藏取消弹框
    handlerCancelShow() {
      this.cancelShow = false;
    },
    // 跳转订单详情
    details(e) {
      // this.$router.push("./orderDetails");
      console.log("e", e);
      this.orderDetails = true;
      this.getCartOrderDetailAction({
        orderId: e.orderId
      }).then(res => {
        console.log("res", res);
        this.orderMsg = res.data;
      });
    },
    // 再次购买
    handleBuyAgain(cartItem) {
      console.log("cartItem",cartItem)
      // 如果存在备注，显示确认对话框
      if (cartItem.remark) {
        this.$Modal.confirm({
          title: 'Tips',
          content: 'This order has a note, please confirm whether the information for repurchase is complete.',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => {
            this.processBuyAgain(cartItem);
          }
        });
      } else {
        // 如果没有备注，直接处理
        this.processBuyAgain(cartItem);
      }
    },
    
    // 抽取购买逻辑到单独的方法
    processBuyAgain(cartItem) {
      let param = {
        orderType: 'buyagain',
        id: cartItem.clothCategory,
        orderId: cartItem.orderId,
      }, routerJump;

      if (cartItem.orderType === 8) {
        routerJump = this.$router.resolve({
          path: '/peofessionalOrder',
          query: {...param, ...{sizeCategoryId: cartItem.sizeCategoryId}}
        });
      } else if (cartItem.orderType === 7) {
        routerJump = this.$router.resolve({path: '/newOrder', query: {...param, ...{type: cartItem.orderType}}});
      } else if (cartItem.orderType === 10) {
        routerJump = this.$router.resolve({path: '/styleOrdering', query: {...param, ...{type: cartItem.orderType}}});
      }
      window.open(routerJump.href, '_blank')
    },
    // 获得订单列表
    addOrder() {
      let that = this;
      this.spinShow = true;

      this.getOrderCartListAction(this.params)
        .then(res => {
          res.data.map(item => {
            item.check = 0;
          });
          this.list = res.data;
          this.total = res.total;
        })
        .finally(function() {
          that.spinShow = false;
        });
    },
    // 修改页数
    changePage(e) {
      this.params.pageNum = e;
      this.addOrder();
    },
    // 修改条数

    changeSize(e) {
      this.params.pageSize = e;
      this.addOrder();
    },
    changeAll() {
      this.list.map(item => {
        item.check = Number(this.allCheck);
      });
    },
    // 修改日期
    changeDate(e) {
      this.paramsLogistics.shipdate = e;
    },
    // 隐藏订单列表 操作
    closeDetails() {
      this.orderDetails = false;
    },
    // 提交
    submitLogistics() {
      this.loading = true;
      this.paramsLogistics.address = this.submitAddress;
      if (this.paramsLogistics.orderIds == "") {
        this.$Message.error(
          this.$t("underProduction.paramsLogisticsTips.orderIds")
        );
      } else if (this.paramsLogistics.shipdate == "") {
        this.$Message.error(
          this.$t("underProduction.paramsLogisticsTips.shipdate")
        );
      } else if (this.paramsLogistics.address == "") {
        this.$Message.error(
          this.$t("underProduction.paramsLogisticsTips.address")
        );
      } else {
        this.putShippingAction(this.paramsLogistics).then(res => {
          if (res.code == 0) {
            this.$Message.success(res.message);
            this.addOrder();
          }
        }).finally(()=>{
          this.loading = false;
        })
      }
    },
    // 设为默认
    setDefault() {
      this.setDefaultAction({
        id: this.submitAddress.id
      }).then(res => {
        if (res.code == 0) {
          this.$Message.success(res.message);
          this.submitAddress.isDefault = 1;
        }
      });
    },
    // 提交
    submit(e) {
      this.addressShow = false;

      if (e) {
        this.selectOneAddressAction({
          id: e
        }).then(res => {
          this.submitAddress = res.data;
        });
      }
    },
    // s返回
    back() {
      this.addressShow = false;
    },
    edit(e) {
      this.addressId = this.submitAddress.id;
      this.addNew = true;
      this.type = 2;
    },
    addAddress() {
      this.addNew = true;
      this.addressId = "";
      this.type = 0;
    },
    handlerAdd(e) {
      this.addressId = "";
      this.addNew = false;
    },
    // 重新请求默认地址
    saveConfirm() {
      this.addNew = false;
      // this.defaultAddress();
    },
    // ，默认地址
    defaultAddress() {
      this.addressListAction({
        isDefault: 1
      }).then(res => {
        if (res.data.length > 0) {
          this.submitAddress = res.data[0];
        } else {
          this.submitAddress = "";
        }
        console.log("res", res);
      });
    },
    // 待发货列表
    // addOrder() {
    //   let that = this;
    //   this.spinShow = true;
    //   this.addOrderAction(this.params)
    //     .then((res) => {
    //       res.data.map((item) => {
    //         item.check = 0;
    //       });
    //       this.total = res.total;
    //       this.list = res.data;
    //     })
    //     .finally(function () {
    //       that.spinShow = false;
    //     });
    // },
    changeCheck() {
      this.calculationNum();
      // this.getOrderSumPriceAction({ orderId: this.ids }).then((res) => {
      //   console.log("res", res);
      //   this.accountBalance = res.data.memberBalance.slice(1);
      //   this.subTotal = res.data.orderPrice || 0;
      // });
      // console.log("id", this.ids,this.paramsLogistics);
    },
    // 计算数量
    calculationNum() {
      this.ids = [];
      const dates=new Array();
      //如果是周天 增加一天
      let day=2;
      if(moment().startOf('month').day()){
       day++;
      }
      dates.push(moment().add(day,'days').format('DD/MM/YYYY'))
      this.list.map(item => {
        if (item.check == 1) {
          dates.push(item.planDeliveryDate)
          this.ids.push(item.orderId);
        }
      });
      dates.sort((a,b)=>{
        return new moment(b, "DD/MM/YYYY").valueOf() -moment(a, "DD/MM/YYYY").valueOf();
      })
      if(this.ids.length>0){
        this.shipDate=moment(dates[0], 'DD/MM/YYYY').format("YYYY-MM-DD");
        this.paramsLogistics.shipdate = this.shipDate;
      }
      this.paramsLogistics.orderIds = this.ids.join(",");
    },
    // 订单详情 操作
    checkOptions(e) {
      console.log("e", e);
      this.getCartOrderDetailAction({
        orderId: e.orderId
      }).then(res => {
        this.orderDetails = true;
        console.log("res", res);
        this.orderMsg = res.data;
      });
    },
    // 回车搜索
    searchs() {
      // console.log('this.orderNums',this.$refs.orderNumSelect.lastRemoteQuery)
      this.params.keyWord = this.$refs.orderNumSelect.lastRemoteQuery;
      this.orderNumList.push({
        orderCode: this.params.keyWord,
        source: ""
      });
      this.orderNums = this.$refs.orderNumSelect.lastRemoteQuery;
      this.params.pageNum == 1;
      this.addOrder();
    },
    // 搜索
    search(e) {
      if (e) {
        this.params = e;
      }
      this.params.pageNum == 1;
      this.closeFilte();
      this.addOrder();
    },
    // 显示搜搜分类
    filterClick() {
      this.orderfilteShow = true;
    },
    // 导出
    async handleExport() {
      let params = this.params;
      let response = await exportOrderList(params);
      var url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/application/vnd.ms-excel"
        })
      );
      let link = document.createElement("a");
      let name = `订单列表${dayjs(new Date()).format("YYYY-MM-DD")}.xls`;
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },
    // 关闭搜索分类
    closeFilte() {
      this.orderfilteShow = false;
    },
    //   选择地址弹框显示
    chooseAddress() {
      this.addressShow = true;
    },
    //   取消弹框
    handlerAddressShow() {
      this.addressShow = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.total-price-box {
  position: relative;
  height: 100vh;
  width: 260px;
  padding-top: 10px;
}
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.search {
  /deep/.ivu-select-single .ivu-select-input {
    height: 40px;
  }
  /deep/.ivu-select-selection {
    height: 40px;
  }
}
.status-box {
  overflow-x: auto;
  width: 1090px;
  margin-left: 40px;
  .status-item {
    margin-right: 50px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
    white-space: nowrap;
  }
}
.title-boxs {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.under-production {
  width: 1440px;
  margin: 0 auto;
  font-family: Roboto;
  .delivery-date-box {
    padding: 10px 0;
    width: 220px;
    border-bottom: 1px solid #ecedef;
    /deep/.ivu-input {
      border: none;
      box-shadow: none;
      text-align: right;
    }
    /deep/.ivu-input-suffix {
      display: none;
      padding-right: 0;
    }
    /deep/.ivu-input-with-suffix {
      padding-right: 0;
    }
    .titles {
      opacity: 1;
      font-weight: 400;
      text-align: left;
      color: #081938;
    }
  }
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
  .list {
    width: 1150px;
    .product-list {
      width: 1150px;
      //   min-height: 100vh;
      margin: 0 auto 20px;
      background: #fff;
      padding: 0 20px;
      position: relative;
      min-height: 100vh;
      .select-all {
        height: 60px;
        width: 1150px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 290px;
        margin-left: auto;
        margin-right: auto;
        background: #ffffff;
        box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
        padding: 14px 30px;
        z-index: 999;
      }
    }
  }
  .address {
    width: 260px;
    padding: 20px;
    border-top: 3px solid #0a4dcc;
    background: #fff;
    // margin-top: 10px;
    height: 100%;
    .title-box {
      margin-bottom: 15px;
      .delivery-address {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        color: #081938;
        line-height: 16px;
      }
      .create-new {
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        color: #0a4dcc;
        line-height: 14px;
      }
    }
    .address-details {
      width: 220px;
      padding: 8px 8px 15px 15px;
      background: #f8f8f8;
      border: 1px dashed #9ba2af;
      margin-bottom: 10px;
      .name {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 500;
        text-align: left;
        color: #081938;
        line-height: 16px;
      }
      .logo {
        width: 32px;
        height: 32px;
        // background: #f8c604;
        border-radius: 4px;
        img {
          width: 32px;
          height: 32px;
        }
      }
      .details {
        opacity: 0.7;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 17px;
        margin: 10px 0;
      }
      .options {
        .edit {
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          text-decoration: underline;
          color: #0a4dcc;
          line-height: 17px;
        }
        .add {
          opacity: 0.4;
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          color: #081938;
          line-height: 17px;
        }
      }
    }
    .choose-another {
      //   opacity: 0.4;
      font-size: 12px;
      font-family: Roboto;
      font-weight: 400;
      text-align: left;
      color: #979eaa;
      line-height: 17px;
      width: 220px;
      height: 47px;
      line-height: 47px;
      border: 1px dashed #e6e8eb;
      text-align: center;
      background: #f8f8f8;
    }
    .orders-selected {
      font-size: 14px;
      font-family: Roboto;
      font-weight: 400;
      text-align: center;
      color: #0a4dcc;
      line-height: 16px;
      margin: 40px 0 10px;
    }
    .options-btn {
      text-align: center;
      border: none;
      width: 220px;
      height: 32px;
      line-height: 32px;
      background: #0a4dcc;
      color: #fff;
      font-size: 14px;
      font-family: Roboto;
      font-weight: 400;
      //   text-align: left;
      color: #ffffff;
      line-height: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/underProduction/underProduction.vue